<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-s-order"></i> 销售单详情
        </el-breadcrumb-item>
      </el-breadcrumb>
      <el-button type="text" @click="goBack" icon="el-icon-back" class="back-btn">返回</el-button>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 销售单信息 -->
      <div class="info-section">
        <div class="section-title">
          <i class="el-icon-info"></i>
          <span>销售单信息</span>
        </div>
        <el-descriptions :column="3" border size="small" class="info-descriptions">
          <el-descriptions-item label="销售单号">
            <span class="order-sn">{{ info.sn || '-' }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="销售日期">
            <span class="time-text">{{ info.order_time || '-' }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="销售人">
            <span class="seller-name">{{ info.seller ? info.seller.name_cn : '-' }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="备注" :span="3">
            <span class="remark-text">{{ info.remark || '-' }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- 销售产品 -->
      <div class="info-section">
        <div class="section-title">
          <i class="el-icon-goods"></i>
          <span>销售产品</span>
        </div>
        <div class="table-wrapper">
          <el-table
            :data="info.goods"
            stripe
            border
            size="medium"
            :header-cell-style="headerCellStyle"
            v-loading="loading"
          >
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column label="产品名称" prop="product_name" min-width="200">
              <template slot-scope="scope">
                <div class="product-name">
                  <i class="el-icon-goods"></i>
                  <span>{{ scope.row.product_name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="数量" prop="num" width="120" align="center">
              <template slot-scope="scope">
                <span class="quantity">{{ removeTrailingZeros(scope.row.num) }} 头</span>
              </template>
            </el-table-column>
            <el-table-column label="重量" prop="weight" width="120" align="center">
              <template slot-scope="scope">
                <span>{{ removeTrailingZeros(scope.row.weight) }} kg</span>
              </template>
            </el-table-column>
            <el-table-column label="单价" prop="price" width="120" align="center">
              <template slot-scope="scope">
                <span>¥{{ removeTrailingZeros(scope.row.price) }} / kg</span>
              </template>
            </el-table-column>
            <el-table-column label="总金额" width="140" align="center">
              <template slot-scope="scope">
                <span class="total-amount">¥{{ (removeTrailingZeros(scope.row.price) * removeTrailingZeros(scope.row.weight)).toFixed(2) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 屠宰单详情 -->
      <div class="info-section" v-if="info1 && info1.id">
        <div class="section-title">
          <i class="el-icon-s-operation"></i>
          <span>屠宰单详情</span>
        </div>
        <el-descriptions :column="4" border size="small" class="info-descriptions">
          <el-descriptions-item label="屠宰单号">
            <span class="order-sn">{{ info1.sn || '-' }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="操作人">{{ info1.operator_name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="屠宰日期">{{ info1.order_time || '-' }}</el-descriptions-item>
          <el-descriptions-item label="来源">
            <el-tag size="small" type="primary" effect="plain">
              {{ info1.from_type == 1 ? '采购单' : '-' }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="屠宰数量">
            <span class="quantity">{{ info1.log ? removeTrailingZeros(info1.log.process_num) : '-' }} 头</span>
          </el-descriptions-item>
          <el-descriptions-item label="屠宰重量">
            <span>{{ info1.log ? removeTrailingZeros(info1.log.process_weight) : '-' }} kg</span>
          </el-descriptions-item>
          <el-descriptions-item label="单价">
            <span>¥{{ info1.log ? removeTrailingZeros(info1.log.process_price) : '-' }} / kg</span>
          </el-descriptions-item>
          <el-descriptions-item label="总金额">
            <span class="total-amount">¥{{ info1.log ? removeTrailingZeros(info1.log.process_total_amount) : '-' }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="备注" :span="4">
            <span class="remark-text">{{ info1.remark || '-' }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- 来源采购单 -->
      <div class="info-section" v-if="info1 && info1.purchaselog && info1.purchaselog.length">
        <div class="section-title">
          <i class="el-icon-document"></i>
          <span>来源采购单</span>
        </div>
        <div class="table-wrapper">
          <el-table
            :data="info1.purchaselog"
            stripe
            border
            size="medium"
            :header-cell-style="headerCellStyle"
          >
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column label="采购单号" min-width="180" prop="purchase.title">
              <template slot-scope="scope">
                <div class="purchase-sn">
                  <i class="el-icon-document"></i>
                  <span>{{ scope.row.purchase ? scope.row.purchase.title : '-' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="产品名称" min-width="150" prop="product.name">
              <template slot-scope="scope">
                <div class="product-name">
                  <i class="el-icon-goods"></i>
                  <span>{{ scope.row.product ? scope.row.product.name : '-' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="屠宰数量" width="120" align="center">
              <template slot-scope="scope">
                <span class="quantity">{{ removeTrailingZeros(scope.row.process_num) }} 头</span>
              </template>
            </el-table-column>
            <el-table-column label="屠宰重量" width="120" align="center">
              <span>{{ removeTrailingZeros(scope.row.process_weight) }} kg</span>
            </el-table-column>
            <el-table-column label="采购价格" width="120" align="center">
              <span>¥{{ scope.row.purchaseitem ? removeTrailingZeros(scope.row.purchaseitem.real_price) : '-' }} / kg</span>
            </el-table-column>
            <el-table-column label="剩余数量" width="120" align="center">
              <span>{{ removeTrailingZeros(scope.row.remain_num) }} 头</span>
            </el-table-column>
            <el-table-column label="剩余重量" width="120" align="center">
              <span>{{ removeTrailingZeros(scope.row.remain_weight) }} kg</span>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 屠宰结果 -->
      <div class="info-section" v-if="info1 && info1.goods && info1.goods.length">
        <div class="section-title">
          <i class="el-icon-data-line"></i>
          <span>屠宰结果</span>
        </div>
        <div class="table-wrapper">
          <el-table
            :data="info1.goods"
            stripe
            border
            size="medium"
            :header-cell-style="headerCellStyle"
            show-summary
            :summary-method="getGoodsSummary"
          >
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column label="产品名称" prop="product_name" min-width="200">
              <template slot-scope="scope">
                <div class="product-name">
                  <i class="el-icon-goods"></i>
                  <span>{{ scope.row.product_name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="数量" prop="num" width="120" align="center">
              <template slot-scope="scope">
                <span class="quantity">{{ removeTrailingZeros(scope.row.num) }} 头</span>
              </template>
            </el-table-column>
            <el-table-column label="重量" prop="weight" width="120" align="center">
              <span>{{ removeTrailingZeros(scope.row.weight) }} kg</span>
            </el-table-column>
            <el-table-column label="单价" prop="price" width="120" align="center">
              <span>¥{{ removeTrailingZeros(scope.row.price) }} / kg</span>
            </el-table-column>
            <el-table-column label="总金额" prop="total_price" width="140" align="center">
              <template slot-scope="scope">
                <span class="total-amount">¥{{ removeTrailingZeros(scope.row.total_price) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-if="!info.sn && !loading" class="empty-state">
        <i class="el-icon-document"></i>
        <p>暂无销售单数据</p>
      </div>
    </el-card>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "sellInfo",
  data() {
    return {
      loading: false,
      info: {
        goods: []
      },
      info1: null,
      addForm: {
        id: '',
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
      }
    }
  },
  mounted() {
    const id = this.$route.query.id
    if (id && !isNaN(id) && id > 0) {
      this.addForm.id = id
      this.getOne()
    } else {
      this.$message.error('销售单ID不存在')
      this.goBack()
    }
  },
  methods: {
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '14px',
        borderBottom: '1px solid #e4e7ed'
      }
    },
    
    goBack() {
      this.$router.go(-1)
    },
    
    removeTrailingZeros(number) {
      if (number == null || isNaN(number)) return 0
      let numberString = number.toString()
      numberString = numberString.replace(/(?:\.0*|(\.\d+?)0+)$/, "$1")
      return parseFloat(numberString)
    },
    
    getGoodsSummary(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (column.property === 'total_price') {
          const total = data.reduce((prev, curr) => prev + (parseFloat(curr.total_price) || 0), 0)
          sums[index] = `¥${total.toFixed(2)}`
        } else if (column.property === 'num') {
          const total = data.reduce((prev, curr) => prev + (parseFloat(curr.num) || 0), 0)
          sums[index] = `${total} 头`
        } else if (column.property === 'weight') {
          const total = data.reduce((prev, curr) => prev + (parseFloat(curr.weight) || 0), 0)
          sums[index] = `${total} kg`
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    
    getOne() {
      this.loading = true
      const param = {
        access_token: this.addForm.access_token,
        company_id: this.addForm.company_id,
        id: this.addForm.id
      }
      this.$axios.findSellOne(param).then((res) => {
        this.loading = false
        if (res.code == 200) {
          this.info = res.data
          this.info.order_time = this.info.order_time ? moment(this.info.order_time * 1000).format('YYYY-MM-DD') : ''
          this.info.add_time = this.info.add_time ? moment(this.info.add_time * 1000).format('YYYY-MM-DD HH:mm:ss') : ''
          
          if (this.info.bom_id) {
            this.getPurchaseOne()
          }
        } else {
          this.$message.error(res.msg || '获取销售单详情失败')
        }
      }).catch(error => {
        this.loading = false
        console.error('获取销售单详情失败:', error)
        this.$message.error('获取销售单详情失败')
      })
    },
    
    getPurchaseOne() {
      const param = {
        access_token: this.addForm.access_token,
        company_id: this.addForm.company_id,
        id: this.info.bom_id
      }
      this.$axios.findBomOne(param).then((res) => {
        if (res.code == 200) {
          this.info1 = res.data
          this.info1.order_time = this.info1.order_time ? moment(this.info1.order_time * 1000).format('YYYY-MM-DD') : ''
          this.info1.add_time = this.info1.add_time ? moment(this.info1.add_time * 1000).format('YYYY-MM-DD HH:mm:ss') : ''
        }
      }).catch(error => {
        console.error('获取屠宰单详情失败:', error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  
  .el-breadcrumb {
    font-size: 14px;
    
    i {
      margin-right: 4px;
    }
  }
  
  .back-btn {
    color: #1677ff;
    
    &:hover {
      color: #4096ff;
    }
  }
}

.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08);
  }
}

.alipay-card .el-card__body {
  padding: 20px 24px;
}

// 信息区块
.info-section {
  margin-bottom: 28px;
  
  .section-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    padding-left: 8px;
    border-left: 3px solid #1677ff;
    
    i {
      font-size: 16px;
      color: #1677ff;
    }
    
    span {
      font-size: 15px;
      font-weight: 600;
      color: #1f2d3d;
    }
  }
}

// 描述列表样式
.info-descriptions {
  ::v-deep .el-descriptions-item__label {
    background: #f8f9fc;
    font-weight: 500;
    color: #606266;
  }
  
  .order-sn {
    font-family: monospace;
    font-weight: 500;
    color: #1677ff;
  }
  
  .time-text {
    font-size: 12px;
    color: #8c8f98;
  }
  
  .seller-name {
    font-weight: 500;
    color: #00b578;
  }
  
  .remark-text {
    color: #606266;
  }
}

// 表格样式
.table-wrapper {
  margin-bottom: 16px;
}

.el-table {
  border-radius: 12px;
  overflow: hidden;
}

.el-table::before {
  display: none;
}

.el-table th {
  background: #fafbfc !important;
  font-weight: 500;
}

.product-name {
  display: flex;
  align-items: center;
  gap: 8px;
  
  i {
    font-size: 16px;
    color: #e6a23c;
  }
  
  span {
    font-weight: 500;
  }
}

.purchase-sn {
  display: flex;
  align-items: center;
  gap: 6px;
  
  i {
    color: #1677ff;
  }
  
  span {
    font-family: monospace;
    font-weight: 500;
    color: #1677ff;
  }
}

.quantity {
  font-weight: 600;
  color: #e6a23c;
}

.total-amount {
  color: #ff4d4f;
  font-weight: 600;
}

// 空状态
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #c0c4cc;
  
  i {
    font-size: 64px;
  }
  
  p {
    margin-top: 16px;
    font-size: 14px;
  }
}
</style>